/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteWorkRate } from './';
import {
    QuoteWorkRateFromJSON,
    QuoteWorkRateFromJSONTyped,
    QuoteWorkRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteDetailsResource
 */
export interface TimeAndMaterialsQuoteDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    projectScope?: string;
    /**
     * 
     * @type {QuoteWorkRate}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    workRate: QuoteWorkRate;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    estimatedEndDate: Date;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    estimatedTotalWorkAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    estimatedTotalLots: number;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteDetailsResource interface.
 */
export function instanceOfTimeAndMaterialsQuoteDetailsResource(value: object): value is TimeAndMaterialsQuoteDetailsResource {
    if (!('workRate' in value) || value['workRate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('estimatedEndDate' in value) || value['estimatedEndDate'] === undefined) return false;
    if (!('estimatedTotalWorkAmount' in value) || value['estimatedTotalWorkAmount'] === undefined) return false;
    if (!('estimatedTotalLots' in value) || value['estimatedTotalLots'] === undefined) return false;
    return true;
}

export function TimeAndMaterialsQuoteDetailsResourceFromJSON(json: any): TimeAndMaterialsQuoteDetailsResource {
    return TimeAndMaterialsQuoteDetailsResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectScope': json['projectScope'] == null ? undefined : json['projectScope'],
        'workRate': QuoteWorkRateFromJSON(json['workRate']),
        'startDate': (new Date(json['startDate'])),
        'estimatedEndDate': (new Date(json['estimatedEndDate'])),
        'estimatedTotalWorkAmount': json['estimatedTotalWorkAmount'],
        'estimatedTotalLots': json['estimatedTotalLots'],
    };
}

export function TimeAndMaterialsQuoteDetailsResourceToJSON(value?: TimeAndMaterialsQuoteDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectScope': value['projectScope'],
        'workRate': QuoteWorkRateToJSON(value['workRate']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'estimatedEndDate': ((value['estimatedEndDate']).toISOString().substring(0,10)),
        'estimatedTotalWorkAmount': value['estimatedTotalWorkAmount'],
        'estimatedTotalLots': value['estimatedTotalLots'],
    };
}

